import { render, staticRenderFns } from "./VoucherAccumulatePoints.vue?vue&type=template&id=4eced42a"
import script from "./VoucherAccumulatePoints.vue?vue&type=script&lang=js"
export * from "./VoucherAccumulatePoints.vue?vue&type=script&lang=js"
import style0 from "./VoucherAccumulatePoints.vue?vue&type=style&index=0&id=4eced42a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports